import { render, staticRenderFns } from "./PersonalModal.vue?vue&type=template&id=09e5da1a&"
import script from "./PersonalModal.vue?vue&type=script&lang=js&"
export * from "./PersonalModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09e5da1a')) {
      api.createRecord('09e5da1a', component.options)
    } else {
      api.reload('09e5da1a', component.options)
    }
    module.hot.accept("./PersonalModal.vue?vue&type=template&id=09e5da1a&", function () {
      api.rerender('09e5da1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/profile/PersonalModal.vue"
export default component.exports